import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import api from "../api/axios";

function AddServices() {
  const [serviceName, setServiceName] = useState("");
  const [prefix, setPrefix] = useState("");
  const [counterId, setCounterId] = useState("");
  const [isActive, setIsActive] = useState(true);

  const [counters, setCounters] = useState([]);

  useEffect(() => {
    loadCounters();
  }, []);

  const loadCounters = async () => {
    try {
      const response = await api.get("/Counter/GetCounter");
      setCounters(response.data);
    } catch (error) {
      console.error("Error loading counters:", error);
    }
  };

  const saveService = async (e) => {
    e.preventDefault();

    const data = {
      serviceName,
      prefix,
      counterId: counterId || null,
      isActive,
    };

    try {
      const response = await api.post("/Service/AddServices", data);

      await Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message || "Service added successfully.",
      });

      // Clear Form
      setServiceName("");
      setPrefix("");
      setCounterId("");
      setIsActive(true);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Something went wrong.",
      });
    }
  };

  return (
    <div className="card shadow">
      <div className="card-header bg-primary text-white">
        <h4 className="mb-0">Add Service</h4>
      </div>

      <div className="card-body">
        <form onSubmit={saveService}>
          <div className="row">
            {/* Service Name */}
              <div className="col-md-6 mb-3">
              <label className="form-label">Service Name</label>

              <input
                type="text"
                className="form-control"
                value={serviceName}
                onChange={(e) => setServiceName(e.target.value)}
                required
              />
            </div>

            {/* Prefix */}
            <div className="col-md-3 mb-3">
              <label className="form-label">Prefix</label>

              <input
                type="text"
                className="form-control"
                value={prefix}
                onChange={(e) => setPrefix(e.target.value)}
                required
              />
            </div>

            {/* Counter Dropdown */}
            <div className="col-md-3 mb-3">
              <label className="form-label">Select Counter</label>

              <select
                className="form-select"
                value={counterId}
                onChange={(e) => setCounterId(e.target.value)}
              >
                <option value="">Select Counter</option>

                {counters.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.counterName}
                  </option>
                ))}
              </select>
            </div>

            {/* Active   <div className="form-check mb-3">*/}
            <div className="p-3 text-center col-md-12 col-12">
              <input
                type="checkbox"
                className="form-check-input"
                id="isActive"
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
              />

              <label className="form-check-label" htmlFor="isActive">
                Active
              </label>
            </div>

            <div className="col-md-12 mb-3 text-center">
              <button type="submit" className="btn btn-success">
                Save Service
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddServices;
